import { useEffect, useState } from 'react';
import { Field } from '../ui/Field';
import { NumberInput } from '../ui/NumberInput';
import { useAdmin } from '../AdminContext';
import { btnSecondary } from '../ui/styles';
type Props = {
  productId: string;
  stock: number | undefined;
};

/**
 * Voorraad van een bestaand product. Slaat meteen op (los van "Opslaan" in de concept-balk),
 * zodat een tekstcorrectie later nooit de voorraad terugzet naar de stand van vanochtend.
 * Is er intussen iets verkocht, dan toont het veld de echte stand en beslist Sarah opnieuw.
 */
export function StockField({
  productId,
  stock
}: Props) {
  const {
    saveStock
  } = useAdmin();
  const [value, setValue] = useState(stock);
  const [busy, setBusy] = useState(false);

  // Nieuwe stand van de server (opgeslagen, of intussen verkocht): het veld volgt.
  useEffect(() => setValue(stock), [stock]);
  const changed = value !== stock;
  const submit = async () => {
    if (!changed || busy) return;
    setBusy(true);
    await saveStock(productId, value);
    setBusy(false);
  };
  return <Field label="Voorraad" hint={changed ? 'Nog niet opgeslagen. Voorraad slaat meteen op, los van de rest.' : stock === 0 ? 'Staat op de site als tijdelijk uitverkocht.' : 'Leeg = niet bijhouden. Slaat meteen op.'} data-id="element-911" data-mp="1fweqsmex2iam">
      <div className="flex gap-2" data-id="element-912" data-mp="11wn848dggdqa">
        <div className="min-w-0 flex-1" data-id="element-913" data-mp="1ylbmmupypiuy">
          <NumberInput allowEmpty value={value} onChange={setValue} placeholder="Niet bijhouden" data-id="element-914" data-mp="1yka09u3hx9xx" />
        </div>
        <button type="button" onClick={() => void submit()} disabled={!changed || busy} className={`${btnSecondary} shrink-0`} data-id="element-915" data-mp="1tnjin2c1m6ae">
          {busy ? 'Bezig…' : 'Bijwerken'}
        </button>
      </div>
    </Field>;
}